import React, { Fragment, useContext, useEffect , useState } from 'react'
import { UserContext } from '../../Context/UserContext.js';
import { jwtDecode } from 'jwt-decode';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { PatientContext } from '../../Context/PatientContext.js';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link , useNavigate } from 'react-router-dom';
import OrderOldPatient from '../OrderOldPatient/OrderOldPatient.jsx';
import style from "./order.module.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx';
import { ProfileContext } from '../../Context/ProfileContext.js';





export default function Order() {
   const [patientState , setPatientState] = useState("") ;
   const [patientName , setPatientName] = useState([]) ;
   const {userToken} = useContext(UserContext) ;
   const {patient , setPatient , loading } = useContext(PatientContext) ;
   const { profile, setProfile } = useContext(ProfileContext); // get setter
   const navigate = useNavigate() ;
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}` 
   } ;
   const token = userToken || localStorage.getItem("token") ;

   console.log(profile)

   //^ Decoded Token And Extract User Information From Token :
   function handleUserData(data){
      const decoded = jwtDecode(token) ;
      if(!data){
         setPatient({
            patient_Name:decoded?.name ,
            birthDay:decoded?.birthDay?.slice(0,10) , 
            gender:decoded?.gender ,
            patient_Phone:decoded?.phone , 
         })
      }else{
         setPatient(data)
      }
   } ;


   //^ Add New Patient in Order : 
   async function submitOrderNewPatient(values){
      setPatientState("") ;
      handleUserData(values) ;
      navigate(`/checkout?profile=${profile}`);
   } ;
   let validationSchemaNewPatient = Yup.object({
      patient_Name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
      patient_Phone:Yup.string().required().trim() ,
      birthDay:Yup.string().required().trim() ,
      gender:Yup.string().required().oneOf(["male" , "female"]) ,
   }) ;
   let formikNewPatient = useFormik({
      initialValues:{
         patient_Name: "" ,
         patient_Phone: "",
         birthDay: "",
         gender:"" ,
      }  , validationSchemaNewPatient , 
      onSubmit:submitOrderNewPatient
   }) ;



   //^ Search Old Patient By Phone :
   async function searchInput (e){
      if(e.target.value.length >= 11){
         searchPatientName(e.target.value)
         // navigate('/order/oldPatient')
      }
      if(e.target.value.length === 0){
         setPatientName([])
      }
   } ;
   async function searchPatientName(phoneNumber){
      let response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/patient?keyword=${phoneNumber}` , {headers:header})
      .catch((error)=>{
         Swal.fire({
            title: "Not Found Patient This Number",
            text: error.response.data.message ,
            icon: "error"
         });
         setPatientName([])
      })
      if(response?.data.message === "success"){
         setPatientName(response.data.patients)
      }
   } ;
   async function getPatientData (id){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/patient/${id}` , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            const{birthDay , gender ,patient_Name ,patient_Phone} = data.patient ;
            setPatient({birthDay:birthDay.slice(0,10) , gender ,patient_Name ,patient_Phone}) ;
            setPatientState("old") ;
         }
      })
      .catch((error)=>{
         Swal.fire({
            title: "Not Found Patient",
            text: error.response.data.message ,
            icon: "error"
         });
      })
   } ;


   function handleRadioChange(e) {
      setPatientState(e.target.value)
   } ;


   useEffect(() => {
      handleUserData()
   }, []) ;
   return (
      <Fragment>
         <CustomTitle title="إنشاء طلب جديد" />
         {loading? <h2>Loading ... <i className="fa-solid fa-spinner fa-spin fa-rotate-180 "></i></h2> : ""}


            <div className="container mb-5 pb-5">

                  <div className=" my-3 p-3 border rounded shadow-sm bg-white">
                     <label className="d-flex align-items-center gap-2 mb-3" style={{ direction: "rtl" }}>
                        <input
                           className="form-check-input"
                           type="radio"
                           name="bookingType"
                           value="currentPatient"
                           onChange={handleRadioChange}
                           checked={patientState === "currentPatient"}
                        />
                        <i className="fas fa-user"></i>
                        <span>حجز لنفس المريض</span>
                     </label>

                     <label className="d-flex align-items-center gap-2 mb-3" style={{ direction: "rtl" }}>
                        <input
                           className="form-check-input"
                           type="radio"
                           name="bookingType"
                           value="other"
                           onChange={handleRadioChange}
                           checked={patientState === "other"}
                        />
                        <i className="fas fa-users"></i>
                        <span>حجز لمريض آخر</span>
                     </label>

                     <label className="d-flex align-items-center gap-2" style={{ direction: "rtl" }}>
                        <input
                           className="form-check-input"
                           type="radio"
                           name="bookingType"
                           value="search"
                           onChange={handleRadioChange}
                           checked={patientState === "search"}
                        />
                        <i className="fas fa-search"></i>
                        <span>البحث برقم التليفون</span>
                     </label>
                  </div>


                  {patientState === "other"? 
                     <form dir='rtl' action="" onSubmit={formikNewPatient.handleSubmit}>
                        <div className="my-1">
                           <label htmlFor="patient_Name" className="form-label"> اسم المريض</label>
                           <input type="text" 
                              value={formikNewPatient.values.patient_Name}
                              onChange={formikNewPatient.handleChange} 
                              onBlur={formikNewPatient.handleBlur}
                              className="form-control" id="patient_Name"  
                              name="patient_Name" 
                              placeholder="اسم المريض" />
                           {formikNewPatient.errors.patient_Name && formikNewPatient.touched.patient_Name?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.patient_Name}</div> :""}
                        </div>



                        <div className="my-1">
                           <label htmlFor="patient_Phone" className="form-label">رقم التليفون</label>
                           {/* <input type="tel"  */}
                           <input type="text" 
                              value={formikNewPatient.values.patient_Phone}
                              onChange={formikNewPatient.handleChange} 
                              onBlur={formikNewPatient.handleBlur}
                              className="form-control" id="patient_Phone"  
                              name="patient_Phone" 
                              placeholder="01X XXX XXX XX" />
                           {formikNewPatient.errors.patient_Phone && formikNewPatient.touched.patient_Phone?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.patient_Phone}</div> :""}
                        </div>



                        <div className="my-1">
                           <label htmlFor="birthDay" className="form-label">تاريخ الميلاد</label>
                           <input type="date" 
                           // <input type="datetime-local" 
                              value={formikNewPatient.values.birthDay}
                              onChange={formikNewPatient.handleChange} 
                              onBlur={formikNewPatient.handleBlur}
                              className="form-control" id="birthDay"  
                              name="birthDay" 
                              placeholder="YYYY-MM-DD" />
                           {formikNewPatient.errors.birthDay  && formikNewPatient.touched.birthDay?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.birthDay}</div> :""}
                        </div>



                        <label htmlFor="">
                           <p className='text-end'>الحالة :</p>
                           <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" 
                                 onChange={formikNewPatient.handleChange} 
                                 onBlur={formikNewPatient.handleBlur}
                                 value="male"
                                 id="male"
                                 name="gender" />
                              <label className="form-check-label" htmlFor="male">ذكر</label>
                           </div>



                           <div className="form-check form-check-inline mx-5">
                              <input className="form-check-input" type="radio" 
                                 onChange={formikNewPatient.handleChange} 
                                 onBlur={formikNewPatient.handleBlur}
                                 value="female"
                                 id="female"
                                 name="gender" />
                              <label className="form-check-label" htmlFor="female">أنثى</label>
                           </div>
                        </label>



                        <div className="d-grid gap-2 col-6 mx-auto">
                           <button  disabled={!(formikNewPatient.isValid && formikNewPatient.dirty)} type="submit" className="btn btn-sm bg-main text-white btn-lg mt-2">أنتقل للدفع</button>
                        </div>
                     </form> 
                  : 
                  ""
                  }


                  {patientState === "old"? 
                     <OrderOldPatient/>
                  : 
                  ""
                  }


                  {patientState === "search"? 
                     <div className='my-2 border border-2 rounded-1 p-2 text-center'>
                        <form dir='rtl' className='mb-2'>
                           <label htmlFor="search" className='form-label'>أدخل رقم موبايل المريض المراد البحث عنة</label>
                           <input type="search" className='form-control p-1 w-75 m-auto' onChange={(e)=>{searchInput(e)}} id='search' placeholder='رقم تليفون المريض ' />
                        </form>
                        {patientName.length? 
                           <div className={`${style.search_container}`}>
                              {patientName.map((ele)=>
                              <div onClick={()=>{getPatientData(ele._id)}} className='d-flex justify-content-between align-items-center border border-2 rounded-2 m-2 px-2 py-1 cart_patient'>
                                 <h6><i className="fa-solid fa-address-card me-4 main-color"></i> {ele.patient_Age} : السن </h6>
                                 <p className='h6 m-0 p-0 '>{ele?.patient_Name?.split(" ").slice(0 , 4).join(" ")}</p>
                              </div>)}
                           </div> 
                        : ""}
                     </div>
                  : 
                  ""
                  }


                  {patientState === "currentPatient" ? 
                     <div className='container '>
                        <div className='ps-4 fw-bold p-3 border rounded shadow-sm'>
                           <p>Name: {patient.patient_Name}</p>
                           <p>Phone: {patient.patient_Phone} </p>
                           <p>Gender: {patient.gender} </p>
                           <p>Birthdate: {patient.birthDay} </p>
                        </div>

                       <div className="text-center my-4">
         <button  
            onClick={() => {
               navigate(`/checkout?profile=${profile}`);
               setProfile(false); 
            }} 
            className="btn btn-sm bg-main text-white btn-lg mt-2 w-50"
         >
            أنتقل للدفع
         </button>
      </div>
                     </div>
                  : ""}
            </div>
         
      </Fragment>
   )
}














































// import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
// import PaymentMethod from '../PaymentMethod/PaymentMethod.jsx'
// import { UserContext } from '../../Context/UserContext.js';
// import { jwtDecode } from 'jwt-decode';
// import * as Yup from 'yup';
// import { useFormik } from 'formik';
// import { PatientContext } from '../../Context/PatientContext.js';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { Link, Navigate, useNavigate } from 'react-router-dom';
// import Loading from '../Loading/Loading.jsx';
// import OrderOldPatient from '../OrderOldPatient/OrderOldPatient.jsx';
// import style from "./order.module.css"
// import CustomTitle from '../CustomTitle/CustomTitle.jsx';





// export default function Order() {
//    const [patientState , setPatientState] = useState("") ;
//    const [user , setUser] = useState({}) ;
//    const [patientName , setPatientName] = useState([]) ;
//    const {userToken } = useContext(UserContext) ;
//    const {patient , setPatient , loading ,  setLoading} = useContext(PatientContext) ;
//    const navigate = useNavigate() ;
//    const btnPaymentMethod = useRef(null) ;
//    const header = {
//       token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}` 
//    } ;


//    const token = userToken || localStorage.getItem("token") ;
//    //^ Decoded Token And Extract User Information From Token :
//    function handleUserData(data){
//       const decoded = jwtDecode(token) ;
//       if(!data){
//          setUser({
//             patient_Name:decoded?.name ,
//             birthDay:decoded?.birthDay?.slice(0,10) , 
//             gender:decoded?.gender ,
//             patient_Phone:decoded?.phone , 
//          })
//       }else{
//          setUser(data)
//       }
//    }


//       //^ Add New Patient in Order : 
//       async function submitOrderNewPatient(values){
//          setPatientState("") ;
//          handleUserData(values) ;
//       }
//       let validationSchemaNewPatient = Yup.object({
//          patient_Name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
//          patient_Phone:Yup.string().required().trim() ,
//          birthDay:Yup.string().required().trim() ,
//          gender:Yup.string().required().oneOf(["male" , "female"]) ,
//       })
//       let formikNewPatient = useFormik({
//          initialValues:{
//             patient_Name: "" ,
//             patient_Phone: "",
//             birthDay: "",
//             gender:"" ,
//          }  , validationSchemaNewPatient , 
//          onSubmit:submitOrderNewPatient
//       })



//       //^ Search Old Patient By Phone :
//          async function searchInput (e){
//             if(e.target.value.length >= 11){
//                searchPatientName(e.target.value)
//                // navigate('/order/oldPatient')
//             }
//             if(e.target.value.length === 0){
//                setPatientName([])
//             }
//          }
//          async function searchPatientName(phoneNumber){
//             let response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/patient?keyword=${phoneNumber}` , {headers:header})
//             .catch((error)=>{
//                Swal.fire({
//                   title: "Not Found Patient This Number",
//                   text: error.response.data.message ,
//                   icon: "error"
//                });
//                setPatientName([])
//             })
//             if(response?.data.message === "success"){
//                setPatientName(response.data.patients)
//             }
//          }
//          async function getPatientData (id){
//             await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/patient/${id}` , {headers:header})
//             .then(({data})=>{
//                if(data.message === "success"){
//                   const{birthDay , gender ,patient_Name ,patient_Phone} = data.patient ;
//                   setPatient({birthDay:birthDay.slice(0,10) , gender ,patient_Name ,patient_Phone}) ;
//                   setPatientState("old") ;
//                }
//             })
//             .catch((error)=>{
//                Swal.fire({
//                   title: "Not Found Patient",
//                   text: error.response.data.message ,
//                   icon: "error"
//                });
//             })
//          }
         


//       // function handlePatientPhone (e){
//       //    if(e.target.value.length === 11){
//       //       setLoading(true) ;
//       //       setUser(prev => ({...prev , patient_Phone: e.target.value}))
//       //       setPatientState("") ;
//       //       btnPaymentMethod.current?.click();
//       //    }
//       // }



//       function handleRadioChange(e) {
//          setPatientState(e.target.value)
//       }
   

//       useEffect(() => {
//          handleUserData()
//       }, [])
//    return (
//       <Fragment>
//          <CustomTitle title="إنشاء طلب جديد" />
//          {loading? <h2>Loading ... <i className="fa-solid fa-spinner fa-spin fa-rotate-180 "></i></h2> : ""}


//             <div className="container mb-5 pb-5">

//                   <div className=" my-3 p-3 border rounded shadow-sm bg-white">
//                      <label className="d-flex align-items-center gap-2 mb-3" style={{ direction: "rtl" }}>
//                         <input
//                            className="form-check-input"
//                            type="radio"
//                            name="bookingType"
//                            value="phone"
//                            // onChange={()=>{btnPaymentMethod.current?.click();}}
//                            // onChange={setPatientState("phone")}
//                            checked={patientState === "phone"}
//                         />
//                         <i className="fas fa-user"></i>
//                         <span>حجز لنفس المريض</span>
//                      </label>

//                      <label className="d-flex align-items-center gap-2 mb-3" style={{ direction: "rtl" }}>
//                         <input
//                            className="form-check-input"
//                            type="radio"
//                            name="bookingType"
//                            value="other"
//                            onChange={handleRadioChange}
//                            checked={patientState === "other"}
//                         />
//                         <i className="fas fa-users"></i>
//                         <span>حجز لمريض آخر</span>
//                      </label>

//                      <label className="d-flex align-items-center gap-2" style={{ direction: "rtl" }}>
//                         <input
//                            className="form-check-input"
//                            type="radio"
//                            name="bookingType"
//                            value="search"
//                            onChange={handleRadioChange}
//                            checked={patientState === "search"}
//                         />
//                         <i className="fas fa-search"></i>
//                         <span>البحث برقم التليفون</span>
//                      </label>
//                   </div>


//                   {patientState === "other"? 
//                      <form dir='rtl' action="" onSubmit={formikNewPatient.handleSubmit}>
//                         <div className="my-1">
//                            <label htmlFor="patient_Name" className="form-label"> اسم المريض</label>
//                            <input type="text" 
//                               value={formikNewPatient.values.patient_Name}
//                               onChange={formikNewPatient.handleChange} 
//                               onBlur={formikNewPatient.handleBlur}
//                               className="form-control" id="patient_Name"  
//                               name="patient_Name" 
//                               placeholder="اسم المريض" />
//                            {formikNewPatient.errors.patient_Name && formikNewPatient.touched.patient_Name?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.patient_Name}</div> :""}
//                         </div>



//                         <div className="my-1">
//                            <label htmlFor="patient_Phone" className="form-label">رقم التليفون</label>
//                            {/* <input type="tel"  */}
//                            <input type="text" 
//                               value={formikNewPatient.values.patient_Phone}
//                               onChange={formikNewPatient.handleChange} 
//                               onBlur={formikNewPatient.handleBlur}
//                               className="form-control" id="patient_Phone"  
//                               name="patient_Phone" 
//                               placeholder="01X XXX XXX XX" />
//                            {formikNewPatient.errors.patient_Phone && formikNewPatient.touched.patient_Phone?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.patient_Phone}</div> :""}
//                         </div>



//                         <div className="my-1">
//                            <label htmlFor="birthDay" className="form-label">تاريخ الميلاد</label>
//                            <input type="date" 
//                            // <input type="datetime-local" 
//                               value={formikNewPatient.values.birthDay}
//                               onChange={formikNewPatient.handleChange} 
//                               onBlur={formikNewPatient.handleBlur}
//                               className="form-control" id="birthDay"  
//                               name="birthDay" 
//                               placeholder="YYYY-MM-DD" />
//                            {formikNewPatient.errors.birthDay  && formikNewPatient.touched.birthDay?<div className="alert alert-danger mt-4 p-2">{formikNewPatient.errors.birthDay}</div> :""}
//                         </div>



//                         <label htmlFor="">
//                            <p className='text-end'>الحالة :</p>
//                            <div className="form-check form-check-inline">
//                               <input className="form-check-input" type="radio" 
//                                  onChange={formikNewPatient.handleChange} 
//                                  onBlur={formikNewPatient.handleBlur}
//                                  value="male"
//                                  id="male"
//                                  name="gender" />
//                               <label className="form-check-label" htmlFor="male">ذكر</label>
//                            </div>



//                            <div className="form-check form-check-inline mx-5">
//                               <input className="form-check-input" type="radio" 
//                                  onChange={formikNewPatient.handleChange} 
//                                  onBlur={formikNewPatient.handleBlur}
//                                  value="female"
//                                  id="female"
//                                  name="gender" />
//                               <label className="form-check-label" htmlFor="female">أنثى</label>
//                            </div>
//                         </label>



//                         <div className="d-grid gap-2 col-6 mx-auto">
//                            <button data-bs-toggle="modal" data-bs-target="#PaymentMethod" disabled={!(formikNewPatient.isValid && formikNewPatient.dirty)} type="submit" className="btn btn-sm bg-main text-white btn-lg mt-2">أنتقل للدفع</button>
//                         </div>
//                      </form> 
//                   : 
//                   ""
//                   }


//                   {patientState === "old"? 
//                      <OrderOldPatient/>
//                   : 
//                   ""
//                   }


//                   {patientState === "search"? 
//                      <div className='my-2 border border-2 rounded-1 p-2 text-center'>
//                         <form dir='rtl' className='mb-2'>
//                            <label htmlFor="search" className='form-label'>أدخل رقم موبايل المريض المراد البحث عنة</label>
//                            <input type="search" className='form-control p-1 w-75 m-auto' onChange={(e)=>{searchInput(e)}} id='search' placeholder='رقم تليفون المريض ' />
//                         </form>
//                         {patientName.length? 
//                            <div className={`${style.search_container}`}>
//                               {patientName.map((ele)=>
//                               <div onClick={()=>{getPatientData(ele._id)}} className='d-flex justify-content-between align-items-center border border-2 rounded-2 m-2 px-2 py-1 cart_patient'>
//                                  <h6><i className="fa-solid fa-address-card me-4 main-color"></i> {ele.patient_Age} : السن </h6>
//                                  <p className='h6 m-0 p-0 '>{ele?.patient_Name?.split(" ").slice(0 , 4).join(" ")}</p>
//                               </div>)}
//                            </div> 
//                         : ""}
//                      </div>
//                   : 
//                   ""
//                   }


//                   {patientState === "phone" ? "Done" : "Not"}

//                   <div className="d-grid gap-2 col-md-6 mx-auto">
//                      <button ref={btnPaymentMethod} data-bs-toggle="modal" data-bs-target="#PaymentMethod" className="btn btn-sm btn-new-color text-white mt-2 d-none">اختار طريقة الدفع</button>
//                   </div>

//                <PaymentMethod user={user}/> 
//             </div>
         
//       </Fragment>
//    )
// }







